// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"36adfa01","239":"d5993601","667":"63fb388a"}[chunkId] + ".chunk.js";
};